/* ============================================
   NLO - NEVER LET OFF
   Global JavaScript
   ============================================ */

// Scroll Animation Observer
document.addEventListener('DOMContentLoaded', function() {
  // Animate elements on scroll
  const animateElements = document.querySelectorAll('.animate-on-scroll');
  
  if (animateElements.length > 0) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animateElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open');
      document.body.classList.toggle('overflow-hidden');
      if (menuOverlay) menuOverlay.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', !isOpen);
    });

    if (menuOverlay) {
      menuOverlay.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        menuOverlay.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Header scroll behavior
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    const headerHeight = header.offsetHeight;

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > headerHeight) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      if (currentScroll > lastScroll && currentScroll > headerHeight * 2) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }
});

// Quantity selector
class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.quantity-selector__input');
    this.btnMinus = this.querySelector('[data-action="minus"]');
    this.btnPlus = this.querySelector('[data-action="plus"]');

    if (this.btnMinus) {
      this.btnMinus.addEventListener('click', this.decrease.bind(this));
    }
    if (this.btnPlus) {
      this.btnPlus.addEventListener('click', this.increase.bind(this));
    }
    if (this.input) {
      this.input.addEventListener('change', this.validate.bind(this));
    }
  }

  decrease() {
    const value = parseInt(this.input.value) - 1;
    if (value >= parseInt(this.input.min || 1)) {
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  increase() {
    const value = parseInt(this.input.value) + 1;
    const max = parseInt(this.input.max || 99);
    if (value <= max) {
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  validate() {
    let value = parseInt(this.input.value);
    const min = parseInt(this.input.min || 1);
    const max = parseInt(this.input.max || 99);
    
    if (isNaN(value) || value < min) value = min;
    if (value > max) value = max;
    
    this.input.value = value;
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}

// Product variant selector
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateURL();
    this.updatePrice();
    this.updateAddToCartButton();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const variants = this.getVariantData();
    this.currentVariant = variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updatePrice() {
    if (!this.currentVariant) return;
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');

    if (priceEl) {
      priceEl.textContent = this.formatMoney(this.currentVariant.price);
    }
    if (comparePriceEl) {
      if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        comparePriceEl.textContent = this.formatMoney(this.currentVariant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
  }

  updateAddToCartButton() {
    if (!this.currentVariant) return;
    const addBtn = document.querySelector('[data-add-to-cart]');
    const variantInput = document.querySelector('[name="id"]');

    if (variantInput) variantInput.value = this.currentVariant.id;

    if (addBtn) {
      if (this.currentVariant.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.dataset.addText || 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.soldText || 'Sold Out';
      }
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', VariantSelector);
}
